import Vue from 'vue'
import App from './serp/Serp.vue'

Vue.config.productionTip = false

new Vue({
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/serp.js